import { render, staticRenderFns } from "./OrderListProductMessages.vue?vue&type=template&id=7a2a0e8c&scoped=true&"
import script from "./OrderListProductMessages.vue?vue&type=script&lang=js&"
export * from "./OrderListProductMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a0e8c",
  null
  
)

export default component.exports